function polling(){
  let _timer;
  let _tasks = []
  let _debug = false;
  let _logs = []
  const events = {
    onProcess: ()=>{}
  }

  function run(_duration=250){
    stop()
    _timer = setInterval(function(){
      _tasks.forEach(function({ id, fun, context, duration, anchor, disabled }, index){
        if(disabled) return
        if(_debug) _logs.push(`${id}(${duration}ms) | anchor:${anchor}ms | reset:${anchor>=duration} | disabled: ${disabled} `)
        events.onProcess({task:{ id, fun, duration, anchor, disabled }, logs:_logs})
        if(anchor>=duration){ //此处执行
          _tasks[index].anchor = 0
          try{
            fun.apply(context.scope, [id, ...context.args])
          }catch(e){
            console.error(e)
          }
        }
        _tasks[index].anchor+=_duration
      })
    }, _duration);
  }
  function stop(){
    clearInterval(_timer)
  }

  const ctx = {
    add(id, fun, context={args:[],scope:this}, duration){
      _tasks.push({
        id,
        fun,
        context,
        duration,
        anchor: 0,
        disabled: false
      })
    },
    remove(id){
      _tasks.splice(_tasks.findIndex(i=>i.id==id), 1)
    },
    clear(){
      _tasks = []
    },
    clearLogs(){
      _logs = []
    },
    run,
    stop,
    pause(id, trigger){
      const task = _tasks.find(i=>i.id==id)
      task.disabled = (typeof trigger == 'undefined' ? !task.disabled : trigger)
    },
    onProcess(fun){
      events.onProcess = fun
    },
    runTask(id){
      const [task] = _tasks.filter(i=>i.id==id)
      try{
        task.fun.apply(task.context.scope, [id, ...task.context.args])
      }catch(e){
        console.log(e)
      }
    }
  }

  Object.defineProperties(ctx,{
    'tasks': {
      get(){ return _tasks }
    },
    'logs':{
      get(){ return _logs }
    },
    'debug':{
      get(){ return _debug },
      set(val){ _debug = val }
    }
  })

  return ctx
}

export default new polling()
